<div #container class="demo-survey-window">
    <button class="demo-survey-window-close-button btn-small nu-btn-icon" (click)="closeClick(true)">
        <svg class="nu-icon nu-icon-small nu-ic-close">
            <use xlink:href="./assets/icons/symbol-defs.svg#nu-ic-close"></use>
        </svg>
    </button>
    <div #window class="demo-survey-window-body">
        @if (!feedbackSent) {
            <div class="demo-survey-window-feedback">
                <h3 class="demo-survey-window-title demo-survey-window-title-feedback">Share Your Feedback</h3>
                @if (showEmojiSection()) {
                    <p class="demo-survey-window-feedback-description">How Was Your Experience With Creately Today ?</p>
                    <div class="demo-survey-window-emoji-container">
                        @for (emoji of emojis; track emoji.id) {
                            <div #emojiTooltip tooltip [placement]="'top'" [class]="{
                                'demo-survey-window-emoji-wrapper': true,
                                'selected': selectedEmoji === emoji.id,
                                'active': activeEmojiId === emoji.id
                            }"
                            (mouseover)="onEmojiHover(emoji.id, true)"
                            (mouseout)="onEmojiHover(emoji.id, false)"
                            (click)="onEmojiClick(emoji.id)">
                                <img class="demo-survey-window-emoji"
                                [src]="'./assets/images/modal-windows/demo-survey/emoji-' + emoji.id + '.svg'"
                                [alt]="emoji.alt"
                                >
                                <span class="tooltip-content">{{emoji.alt}}</span>
                            </div>
                        }
                    </div>
                } @else if (showRatingReasons()) {
                    <div class="demo-survey-window-rating-reasons">
                        <div class="rating-reasons-list">
                            <div class="rating-reasons-heading">{{getSelectedEmojiData()?.ratingReasons?.heading}}</div>
                            <div class="rating-reasons-options">
                                @for (option of getSelectedEmojiData()?.ratingReasons?.options || []; track option) {
                                    <div [class]="{
                                        'rating-reason-option': true,
                                        'selected': selectedRatingReason === option
                                    }" (click)="selectRatingReason(option)">
                                        {{ option }}
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                } @else if (showFeedbackTextArea()) {
                    <div class="demo-survey-window-text-feedback">
                        <textarea #feedbackText [placeholder]="getSelectedEmojiData()?.textArea?.placeholder" maxlength="400"></textarea>
                    </div>
                    <button class="btn btn-primary btn-large send-feedback-btn" (click)="sendFeedback()" [disabled]="!selectedEmoji">Send Feedback</button>
                }
                @if (!showFeedbackTextArea()) {
                    <div class="demo-survey-window-step-container">
                        @for (step of [1, 2, 3]; track step) {
                            <span [class]="{
                                'demo-survey-window-step': true,
                                'active': step === activeStep()
                            }"></span>
                        }
                    </div>
                }
            </div>
        } @else {
            <div class="demo-survey-window-feedback-sent">
                <svg class="nu-icon demo-survey-window-feedback-sent-icon">
                    <use xlink:href="./assets/icons/symbol-defs.svg#nu-ic-check-chat-circle"></use>
                </svg>
                <h3 class="demo-survey-window-title demo-survey-window-title-feedback-sent">Thank You !</h3>
                <p class="demo-survey-window-feedback-sent-description">We're grateful for your input! Your feedback helps us make Creately even better.</p>
                <button class="btn btn-primary btn-large" (click)="closeClick()">Done</button>
            </div>
        }
    </div>
</div>
